// extracted by mini-css-extract-plugin
module.exports = {"tableButtons":"style__tableButtons__sPVlW","modalBody":"style__modalBody__8viz2","modalButtons":"style__modalButtons__kVXjP"};